// extracted by mini-css-extract-plugin
export var playButton = "PlayIcon_playButton__FzGIX";
export var hero = "PlayIcon_hero__E41-H";